module.exports = __webpack_public_path__ + "static/media/ic-editar.ea61ee74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/ic-editar.svg
// module id = 1074
// module chunks = 0